import React, { Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

type PageModule = { default: React.ComponentType<Record<string, never>> };

/** Keep the route lazy loader synchronous so React Router can render Suspense while the chunk downloads. */
export function createLazyRoute(
  loader: () => Promise<PageModule>,
  fallback: React.ReactNode,
): NonNullable<RouteObject['lazy']> {
  const LazyPage = React.lazy(loader);
  return async () => ({
    Component: () => (
      <Suspense fallback={fallback}>
        <LazyPage />
      </Suspense>
    ),
  });
}
